export default "__VITE_ASSET__Ba3DNiDM__"